import { prepareRegFlowHashForPulseInit } from '~/utils/location-av-chart-deeplink'

/** Fallback if SSR bootstrap did not run: clear `#reg-flow` hash so Pulse uses `data-page`. */
export default defineNuxtPlugin(() => {
  prepareRegFlowHashForPulseInit()
})
